"use client"

import { ChevronRightIcon } from "@heroicons/react/16/solid"
import { FeatureFlagsContext } from "@src/providers/FeatureFlagsProvider"
import Link from "next/link"
import { useContext } from "react"

export function SidebarPromotionLink() {
  const { isPromotionsDisabled } = useContext(FeatureFlagsContext)

  if (isPromotionsDisabled) {
    return null
  }

  return (
    <Link
      href="/near-x"
      className="-outline-offset-1 hover:-outline-offset-2 focus-visible:-outline-offset-2 relative flex items-center justify-between gap-2 overflow-hidden rounded-2xl bg-green-500 p-3.5 text-black outline outline-gray-900/10 hover:outline-2 hover:outline-green-800 focus-visible:outline-2 focus-visible:outline-green-800 dark:bg-green-950 dark:text-white dark:outline-green-500/5 dark:focus-visible:outline-green-700 dark:hover:outline-green-700"
    >
      <span className="font-semibold text-sm/5 tracking-tight selection:bg-black! selection:text-green-500! dark:selection:bg-green-500! dark:selection:text-black!">
        Join NEAR@3.33, earn rewards
      </span>
      <ChevronRightIcon className="size-5 shrink-0" />
    </Link>
  )
}
